import { Routes } from '@angular/router';
import { HomeComponent } from "./home/home.component";
import { AboutComponent } from "./about/about.component";
import { ContactComponent } from "./contact/contact.component";
import { PolicyComponent } from "./policy/policy.component";
import { ProductComponent } from "./product/product.component";
import { ProductOrderComponent } from "./product-order/product-order.component";
import { AddOrderComponent } from "./add-order/add-order.component";
import { RegistrationComponent } from "./registration/registration.component";
import { PaymentComponent } from "./payment/payment.component";
import { MyaccountComponent } from "./myaccount/myaccount.component";

export const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'home', component: HomeComponent },
    { path: 'about', component: AboutComponent, title: 'Gudiya Enterprises: About' },
    { path: 'product', component: ProductComponent, title: 'Gudiya Enterprises: Products' },
    { path: 'policy', component: PolicyComponent, title: 'Gudiya Enterprises: Privacy Policy' },
    { path: 'contact', component: ContactComponent, title: 'Gudiya Enterprises: Contact' },
    { path: 'checkout', component: ProductOrderComponent, title: 'Gudiya Enterprises: Checkout' },
    { path: 'add-order', component: AddOrderComponent, title: 'Gudiya Enterprises: Order' },
    { path: 'registration', component: RegistrationComponent, title: 'Gudiya Enterprises: Registration' },
    { path: 'payment', component: PaymentComponent, title: 'Gudiya Enterprises: Payment' },
    { path: 'myaccount', component: MyaccountComponent, title: 'Gudiya Enterprises: Accounts' },

    { path: '**', redirectTo: '', pathMatch: 'full' }
];
